import Vue from 'vue';
import Router, { Route }  from 'vue-router';
import Barcode from './views/Transaction/components/BarcodeDialog.vue';
import BarcodeSetting from './views/Transaction/components/BarcodeSetting.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/barcode',
      name: 'barcode',
      component: Barcode,
      props: {isBarcodeRouter:true}        
    },
    {
      path: '/barcode/setting',
      name: 'setting',
      component: BarcodeSetting, 
    },    
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
    },       
  ],
});

